export default __webpack_public_path__ + "static/media/infographic.d83795e0.png";